import React from 'react'
import About from './components/About'
import Certificate from './components/Certificate'
import Contact from './components/Contact'
import Hero from './components/Hero'
import Navbar from './components/Navbar'
import Portfolio from './components/Portfolio'

export default function App() {
  return (
    <div>
      <div className='bg-[#DEE1E4] font-body'>
        <div>
          <div className='bg-hero relative bg-cover after:bg-opacity-50 after:bg-[#979494] after:content-[""] after:w-full after:h-full after:absolute after:bottom-0' >
            <Navbar />
            <Hero />
          </div>
        </div>
      </div>
      <About />
      <Portfolio />
      <Certificate />
      <Contact />
    </div>
  )
}
